import axios from 'axios';

const bookingApi = axios.create({
  baseURL: process.env.REACT_APP_BOOKING_API_BASE_URL,
  headers: {
    apikey: process.env.REACT_APP_BOOKING_API_KEY,
    clientkey: process.env.REACT_APP_BOOKING_API_CLIENT_KEY,
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  },
});
export default bookingApi;
